import { Action } from '../actions';

const DEFAULT_STATE = {
  loading: false,
  error: undefined,
  totalPages: 0,
  page: 0,
  cards: [],
  count: 0,
};

export default function (wexcards = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case Action.Payment.WexCards.LoadRequested: {
      return {
        ...wexcards,
        loading: true,
        error: undefined,
      };
    }

    case Action.Payment.WexCards.LoadCompleted: {
      const { body } = payload;

      return {
        ...wexcards,
        cards: body.cards || [],
        count: body.count || 0,
        error: body.error,
        loading: false,
        page: body.page || 0,
        totalPages: body.totalPages || 0,
      };
    }

    default: {
      return wexcards;
    }
  }
}
